module.exports = "/static/media/lineto-circular-mediumItalic.82a2a90b.woff";